export default {
  metadata: {
    version: '1.0.0',
    id: 'input_phone_dropdown-1.0.0',
    name: 'JDSInputPhoneDropdown'
  },
  hierarchy: {
    'vertical-container': [
      {
        container: [
          {
            'prefix-jds-icon-container': ['prefix-jds-icon']
          },
          'country_code-jds-text',
          {
            'chevron-jds-icon-container': ['chevron-jds-icon']
          }
        ]
      },
      'jds_menu_block'
    ]
  },
  base: {
    'vertical-container': {
      'flex-direction': '{flexDirection.column}'
    },
    container: {
      'flex-direction': '{flexDirection.row}',
      gap: '{xxs}'
    },
    jds_menu_block: {
      open: false
    },
    'prefix-jds-icon': {
      size: '{icon_5}',
      color: '{icon_7}'
    },
    'prefix-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'country_code-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    },
    'chevron-jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}',
      value: 'ic_chevron_down',
      ic: 'ic_chevron_down'
    },
    'chevron-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      ic: 'ic_chevron_down'
    }
  },
  variant: {
    open: {
      true: {
        jds_menu_block: {
          open: true
        },
        'chevron-jds-icon': {
          value: 'ic_chevron_up',
          ic: 'ic_chevron_up'
        },
        'chevron-jds-icon-container': {
          ic: 'ic_chevron_up'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true
        }
      }
    }
  },
  combination: [],
  combination_config: [],
  api: {
    config: {
      open: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_menu_block: {
        items: {
          type: 'list',
          name: 'items',
          object: {
            type: 'JDSMenuBlockItem.type',
            label: 'string',
            value: 'string',
            prefix: 'icon',
            suffix: 'icon',
            disabled: 'boolean'
          }
        },
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex'
        },
        offsetX: {
          type: 'size',
          name: '_offsetX'
        },
        offsetY: {
          type: 'size',
          name: '_offsetY'
        },
        minWidth: {
          type: 'size',
          name: '_minWidth'
        },
        maxWidth: {
          type: 'size',
          name: '_maxWidth'
        },
        maxHeight: {
          type: 'size',
          name: '_maxHeight'
        }
      },
      'country_code-jds-text': {
        value: {
          type: 'string',
          name: 'countryCode'
        },
        color: {
          type: 'JDSText.color',
          name: 'countryCodeColor'
        }
      },
      'prefix-jds-icon': {
        value: {
          type: 'icon',
          name: 'countryFlag'
        }
      }
    },
    events: {
      container: {
        onClick: 'onOpen',
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        }
      },
      jds_menu_block: {
        onSelect: {
          name: 'onSelect',
          object: {
            index: 'number',
            value: 'string'
          }
        },
        onClose: 'onClose'
      }
    },
    a11y: {
      'vertical-container': {
        properties: {
          role: {
            value: 'menu'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Select Country Code'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_menu_block: {
        name: 'items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
